"use client";

import useToast from "@/stores/toast";
import useUnavailableProduct from "@/stores/unavailable-product";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

export default function UnavailableProductNotification() {
  const { loading, payload, setPayload, open, cancel, submit } =
    useUnavailableProduct();
  const { toast } = useToast();

  return (
    <>
      <Dialog open={open} onClose={cancel}>
        <DialogTitle>Join the waiting list</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Get notified when the product is back in stock
          </DialogContentText>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            margin="dense"
            value={payload.name}
            onChange={(e) => {
              setPayload("name", e.target.value);
            }}
          />
          <TextField
            fullWidth
            label="Phone Number"
            variant="outlined"
            margin="dense"
            value={payload.phone}
            onChange={(e) => {
              setPayload("phone", e.target.value);
            }}
          />
          <TextField
            fullWidth
            label="Email Address"
            variant="outlined"
            margin="dense"
            value={payload.email}
            onChange={(e) => {
              setPayload("email", e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cancel}>Cancel</Button>
          <Button
            loading={loading}
            disabled={loading}
            onClick={async () => {
              const response = await submit();

              toast(response);
            }}
            autoFocus
            variant="contained"
          >
            Join now
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
